import React from 'react'
import { FormattedDate } from 'react-intl'

import { IContest } from 'protos'

import T from 'components/FormattedMessage'

import Label from './Label'

interface Props {
  endTime: IContest['endTime']
}

const FinishedLabel: React.SFC<Props> = ({ endTime }) => (
  <Label
    label={<T id="contests_finishtime" />}
    value={<FormattedDate value={+(endTime || 0) * 1000} year="numeric" month="short" day="2-digit" />}
  />
)

export default FinishedLabel
